/**
 * product-recall-form.js
 * Handles:
 *  - Recall product card click → scroll to form + pre-fill product field
 *  - File upload with preview and validation
 *  - Form validation
 *  - Google Places address autocomplete
 *  - Gorgias ticket submission with file attachments
 */

(function () {
  var API_URL = 'https://gc-tickets.vercel.app/api/create-ticket';

  document.addEventListener('DOMContentLoaded', function () {
    // ── Product card click handlers ────────────────────────────────────────

    var cardButtons = document.querySelectorAll('.recall-products__card-btn');
    cardButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var anchor = document.getElementById('recall-form-anchor');
        if (anchor) {
          setTimeout(function () {
            anchor.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }, 80);
        }
      });
    });

    // ── Form setup ────────────────────────────────────────────────────────

    var wrapper = document.getElementById('recall-form-wrapper');
    if (!wrapper) return;

    var form = wrapper.querySelector('form');
    if (!form) return;

    // Replace to strip any previously bound listeners
    var newForm = form.cloneNode(true);
    form.parentNode.replaceChild(newForm, form);

    // Honeypot
    var hpDiv = document.createElement('div');
    hpDiv.style.cssText = 'position:absolute;left:-9999px;opacity:0;';
    hpDiv.setAttribute('aria-hidden', 'true');
    var hpInput = document.createElement('input');
    hpInput.type         = 'text';
    hpInput.name         = 'website_url_confirm';
    hpInput.tabIndex     = -1;
    hpInput.autocomplete = 'off';
    hpInput.setAttribute('aria-hidden', 'true');
    hpDiv.appendChild(hpInput);
    newForm.appendChild(hpDiv);

    // ── File upload ───────────────────────────────────────────────────────

    var uploadedFiles = [];
    initFileUpload(newForm);
    setupGooglePlaces(newForm);

    // ── Clear custom required-field errors on input ────────────────────────
    ['recallFirstName', 'recallLastName', 'recallEmail', 'recallAddress',
     'recallCity', 'recallState', 'recallZip', 'recallCountry',
     'recallProductSku', 'recallLotNumber'].forEach(function (id) {
      var input = newForm.querySelector('#' + id);
      if (!input) return;
      input.addEventListener('input', function () {
        if (input.value.trim()) {
          input.classList.remove('input-error');
          var span = input.nextElementSibling;
          if (span) span.removeAttribute('data-after');
        }
      });
    });

    // ── Order source "Other" toggle + Order ID placeholder ───────────────
    var orderSourceSelect = newForm.querySelector('#recallOrderSource');
    var orderSourceOtherWrap = newForm.querySelector('#recallOrderSourceOtherWrap');
    var orderIdInput = newForm.querySelector('#recallOrderId');

    var orderIdPlaceholders = {
      'Guidecraft.com':       'e.g. #GCS1234',
      'Amazon.com':           'e.g. 123-4567890-1234567',
      'Target.com':           'e.g. 102938471625',
      'Wayfair.com':          'e.g. 3910944401',
      'Walmart.com':          'e.g. 1234567890123',
      'Maisonette.com':       'e.g. M-123456',
      'Ebay.com':             'e.g. 12-34567-89012',
      'Facebook Marketplace': 'Please enter order ID',
      'Other':                'Please enter order ID'
    };

    if (orderSourceSelect) {
      orderSourceSelect.addEventListener('change', function () {
        var val = this.value;
        if (orderSourceOtherWrap) {
          orderSourceOtherWrap.style.display = val === 'Other' ? 'block' : 'none';
        }
        if (orderIdInput) {
          orderIdInput.placeholder = orderIdPlaceholders[val] || 'Please enter order ID';
        }
      });
    }

    // ── File upload required: show error on every submit attempt ─────────
    var submitBtnEl = newForm.querySelector('.recall-form__submit');
    if (submitBtnEl) {
      submitBtnEl.addEventListener('click', function () {
        var fileError = newForm.querySelector('#recallFileError');
        var uploadZone = newForm.querySelector('#recallUploadZone');
        if (uploadedFiles.length === 0) {
          if (fileError) {
            fileError.textContent = 'Please upload at least one photo.';
            fileError.style.display = 'block';
          }
          if (uploadZone) uploadZone.classList.add('recall-upload--error');
        } else {
          if (fileError) fileError.style.display = 'none';
          if (uploadZone) uploadZone.classList.remove('recall-upload--error');
        }
      });
    }

    // ── Form submit ───────────────────────────────────────────────────────

    newForm.addEventListener('submit', async function (e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      var hp = newForm.querySelector('[name="website_url_confirm"]');
      if (hp && hp.value) return;

      var formData = new FormData(newForm);
      var fields   = Object.fromEntries(formData);

      var hasValidationError = false;

      // All required text fields
      var requiredMap = {
        recallFirstName:  'Required',
        recallLastName:   'Required',
        recallAddress:    'Required',
        recallCity:       'Required',
        recallState:      'Required',
        recallZip:        'Required',
        recallCountry:    'Required',
        recallProductSku: 'Required',
        recallLotNumber:  'Required'
      };

      Object.keys(requiredMap).forEach(function (id) {
        var input = newForm.querySelector('#' + id);
        if (!input) return;
        var span = input.nextElementSibling;
        if (!input.value.trim()) {
          input.classList.add('input-error');
          if (span) span.setAttribute('data-after', requiredMap[id]);
          hasValidationError = true;
        } else {
          input.classList.remove('input-error');
          if (span) span.removeAttribute('data-after');
        }
      });

      // Email — empty + format check
      var emailInput = newForm.querySelector('#recallEmail');
      if (emailInput) {
        var emailSpan = emailInput.nextElementSibling;
        var emailVal  = emailInput.value.trim();
        if (!emailVal || !emailInput.checkValidity()) {
          emailInput.classList.add('input-error');
          if (emailSpan) emailSpan.setAttribute('data-after', emailVal ? 'Invalid email' : 'Required');
          hasValidationError = true;
        } else {
          emailInput.classList.remove('input-error');
          if (emailSpan) emailSpan.removeAttribute('data-after');
        }
      }

      // Required select fields
      var selectFields = { recallYearOfPurchase: 'Required' };
      Object.keys(selectFields).forEach(function (id) {
        var select = newForm.querySelector('#' + id);
        if (!select) return;
        var span = select.nextElementSibling;
        if (!select.value) {
          select.classList.add('input-error');
          if (span) span.setAttribute('data-after', selectFields[id]);
          hasValidationError = true;
        } else {
          select.classList.remove('input-error');
          if (span) span.removeAttribute('data-after');
        }
      });

      var fileError  = newForm.querySelector('#recallFileError');
      var uploadZone = newForm.querySelector('#recallUploadZone');
      if (uploadedFiles.length === 0) {
        if (fileError) {
          fileError.textContent = 'Please upload at least one photo.';
          fileError.style.display = 'block';
        }
        if (uploadZone) uploadZone.classList.add('recall-upload--error');
        hasValidationError = true;
      } else {
        if (fileError) fileError.style.display = 'none';
        if (uploadZone) uploadZone.classList.remove('recall-upload--error');
      }

      if (hasValidationError) return;

      var submitBtn  = newForm.querySelector('.recall-form__submit');
      var submitText = newForm.querySelector('.recall-form__submit-text');
      var spinner    = newForm.querySelector('.recall-form__spinner');

      if (submitBtn)  submitBtn.disabled = true;
      if (submitText) submitText.style.display = 'none';
      if (spinner)    spinner.style.display = 'inline';

      var email     = fields['contact[email]']         || '';
      var firstName = fields['contact[first_name]']    || '';
      var lastName  = fields['contact[last_name]']     || '';
      var phone     = fields['contact[phone]']         || '';
      var address   = fields['contact[address]']       || '';
      var city      = fields['contact[city]']          || '';
      var state     = fields['contact[state]']         || '';
      var zip       = fields['contact[zip]']           || '';
      var country   = fields['contact[country]']       || '';
      var lotNumber      = fields['contact[lot_number]']       || '';
      var orderId        = fields['contact[order_id]']         || '';
      var orderSource    = fields['contact[order_source]']     || '';
      var orderSourceOther = fields['contact[order_source_other]'] || '';
      if (orderSource === 'Other' && orderSourceOther) orderSource = orderSourceOther;
      var product        = fields['contact[recalled_product]'] || '';
      var receivedLetter = newForm.querySelector('#recallReceivedLetter').checked ? 'true' : 'false';
      //var notes     = fields['contact[body]']          || '';
      var fullName  = (firstName + ' ' + lastName).trim();
      var yearOfPurchase = fields['contact[year_of_purchase]'] || '';

      // var messageBody = [
      //   'PRODUCT RECALL REQUEST',
      //   '─────────────────────────',
      //   'Name:    ' + fullName,
      //   'Email:   ' + email,
      //   'Phone:   ' + (phone || 'N/A'),
      //   '',
      //   'Shipping Address:',
      //   '  ' + (address || 'N/A'),
      //   '  ' + [city, state, zip].filter(Boolean).join(', '),
      //   '  ' + (country || 'N/A'),
      //   '',
      //   'Recalled Product: ' + (product || 'N/A'),
      //   'Lot Number:       ' + (lotNumber || 'N/A'),
      //   'Order ID:         ' + (orderId || 'N/A'),
      //   '',
      //   'Description of Issue:',
      //   notes || 'None',
      //   '',
      //   'Attachments: ' + (uploadedFiles.length ? uploadedFiles.length + ' file(s) attached' : 'None')
      // ].join('\n');

      try {
        var payload = new FormData();
        payload.append('formType',  'product-recall');
        payload.append('email',     email);
        payload.append('name',      fullName);
        payload.append('firstName', firstName);
        payload.append('lastName',  lastName);
        payload.append('phone',     phone);
        payload.append('address', address);
        payload.append('city',    city);
        payload.append('state',   state);
        payload.append('zip',     zip);
        payload.append('country', country);
        payload.append('product',   product);
        payload.append('lotNumber',    lotNumber);
        payload.append('orderId',      orderId);
        payload.append('orderSource',  orderSource);
        payload.append('received_letter', false);
        //payload.append('notes',     notes);
        payload.append('subject',   ('Product Recall - ' + (product || fullName)).trim());
        var rawOrderSource = fields['contact[order_source]'] || '';
        var sourceTagMap = {
          'Guidecraft.com':       'purchased-guidecraft',
          'Amazon.com':           'purchased-amazon',
          'Target.com':           'purchased-target',
          'Wayfair.com':          'purchased-wayfair',
          'Walmart.com':          'purchased-walmart',
          'Maisonette.com':       'purchased-maisonette',
          'Ebay.com':             'purchased-ebay',
          'Facebook Marketplace': 'purchased-facebook-marketplace',
          'Other':                'purchased-other'
        };
        var recallTags = ['product-recall', 'recall-letter-unverified', 'yop-' + yearOfPurchase.toLowerCase().replace(/\s+/g, '-')];
        var sourceTag = sourceTagMap[rawOrderSource];
        if (sourceTag) recallTags.push(sourceTag);
        if (lotNumber) recallTags.push('lot-' + lotNumber.trim().toLowerCase().replace(/\s+/g, '-'));
        payload.append('tags', JSON.stringify(recallTags));
        payload.append('yearOfPurchase',  yearOfPurchase);

        uploadedFiles.forEach(function (file) {
          payload.append('attachments', file, file.name);
        });

        var resp   = await fetch(API_URL, { method: 'POST', body: payload });
        var result = await resp.json();

        if (resp.ok && result) {
          var attachmentWarning = (result.filesRejected > 0)
            ? ' Note: ' + result.filesRejected + ' attachment(s) could not be uploaded — please email your photos directly to our support team.'
            : '';
          showSuccessMessage(newForm, result.ticketId, email, attachmentWarning);
          newForm.reset();
          uploadedFiles = [];
          var fileList = newForm.querySelector('#recallFileList');
          if (fileList) fileList.innerHTML = '';
        } else {
          showErrorMessage(newForm, 'Failed to submit. Please try again.');
        }
      } catch (_) {
        showErrorMessage(newForm, 'An error occurred. Please try again.');
      } finally {
        if (submitBtn)  submitBtn.disabled = false;
        if (submitText) submitText.style.display = 'inline';
        if (spinner)    spinner.style.display = 'none';
      }

      return false;
    }, true);

    // ── File upload logic ─────────────────────────────────────────────────

    function initFileUpload(form) {
      var fileInput  = form.querySelector('#recallFileUpload');
      var uploadZone = form.querySelector('#recallUploadZone');
      var fileList   = form.querySelector('#recallFileList');
      var errorEl    = form.querySelector('#recallFileError');

      if (!fileInput || !fileList) return;

      var maxFiles   = parseInt(fileInput.dataset.maxFiles   || '5',  10);
      var maxSizeMb  = parseFloat(fileInput.dataset.maxSizeMb  || '10', 10);
      var maxBytes   = maxSizeMb * 1024 * 1024;

      fileInput.addEventListener('change', function () {
        addFiles(Array.from(this.files));
        this.value = '';
      });

      if (uploadZone) {
        uploadZone.addEventListener('dragover', function (e) {
          e.preventDefault();
          uploadZone.classList.add('recall-upload--dragover');
        });
        uploadZone.addEventListener('dragleave', function () {
          uploadZone.classList.remove('recall-upload--dragover');
        });
        uploadZone.addEventListener('drop', function (e) {
          e.preventDefault();
          uploadZone.classList.remove('recall-upload--dragover');
          addFiles(Array.from(e.dataTransfer.files));
        });
      }

      function addFiles(incoming) {
        if (errorEl) errorEl.style.display = 'none';

        var rejected = [];
        incoming.forEach(function (file) {
          if (uploadedFiles.length >= maxFiles) {
            rejected.push(file.name + ' (max ' + maxFiles + ' files reached)');
            return;
          }

          // Check total size including new file
          var currentTotal = uploadedFiles.reduce(function (sum, f) { return sum + f.size; }, 0);
          if (currentTotal + file.size > maxBytes) {
            rejected.push(file.name + ' (total upload limit of ' + maxSizeMb + 'MB exceeded)');
            return;
          }

          var dupe = uploadedFiles.some(function (f) {
            return f.name === file.name && f.size === file.size;
          });
          if (!dupe) uploadedFiles.push(file);
        });

        if (rejected.length && errorEl) {
          errorEl.textContent = rejected.join(' · ');
          errorEl.style.display = 'block';
        }

        renderFileList();
      }

      function renderFileList() {
        fileList.innerHTML = '';
        uploadedFiles.forEach(function (file, idx) {
          var item = document.createElement('div');
          item.className = 'recall-upload__file-item';

          var isPdf = file.type === 'application/pdf';

          if (isPdf) {
            var badge = document.createElement('div');
            badge.className = 'recall-upload__file-thumb recall-upload__file-thumb--pdf';
            badge.textContent = 'PDF';
            item.appendChild(badge);
          } else {
            var thumb = document.createElement('img');
            thumb.className = 'recall-upload__file-thumb';
            thumb.alt       = file.name;
            var reader = new FileReader();
            reader.onload = (function (img) {
              return function (e) { img.src = e.target.result; };
            }(thumb));
            reader.readAsDataURL(file);
            item.appendChild(thumb);
          }

          var info = document.createElement('div');
          info.className = 'recall-upload__file-info';

          var name = document.createElement('div');
          name.className   = 'recall-upload__file-name';
          name.textContent = file.name;

          var size = document.createElement('div');
          size.className   = 'recall-upload__file-size';
          size.textContent = formatBytes(file.size);

          info.appendChild(name);
          info.appendChild(size);
          item.appendChild(info);

          var removeBtn = document.createElement('button');
          removeBtn.type      = 'button';
          removeBtn.className = 'recall-upload__file-remove';
          removeBtn.innerHTML = '&times;';
          removeBtn.setAttribute('aria-label', 'Remove ' + file.name);
          removeBtn.addEventListener('click', (function (i) {
            return function () {
              uploadedFiles.splice(i, 1);
              renderFileList();
              if (errorEl) errorEl.style.display = 'none';
            };
          }(idx)));
          item.appendChild(removeBtn);

          fileList.appendChild(item);
        });
      }
    }

    // ── Google Places ─────────────────────────────────────────────────────

    function setupGooglePlaces(form) {
      window._recallAutoCompleteInit = function () {
        var addressInput = form.querySelector('#recallAddress');
        if (!addressInput) return;
        if (!window.google || !window.google.maps || !window.google.maps.places) return;

        var autocomplete = new google.maps.places.Autocomplete(addressInput, {
          types:  ['address'],
          fields: ['address_components']
        });

        autocomplete.addListener('place_changed', function () {
          var place = autocomplete.getPlace();
          if (!place || !place.address_components) return;

          var streetNumber = '', route = '', city = '', state = '', zip = '', country = '';

          place.address_components.forEach(function (component) {
            var types = component.types;
            if      (types.indexOf('street_number')                !== -1) streetNumber = component.long_name;
            else if (types.indexOf('route')                        !== -1) route        = component.long_name;
            else if (types.indexOf('locality')                     !== -1) city         = component.long_name;
            else if (types.indexOf('administrative_area_level_1')  !== -1) state        = component.long_name;
            else if (types.indexOf('postal_code')                  !== -1) zip          = component.long_name;
            else if (types.indexOf('country')                      !== -1) country      = component.long_name;
          });

          addressInput.value = [streetNumber, route].filter(Boolean).join(' ');

          var cityInput    = form.querySelector('#recallCity');
          var stateInput   = form.querySelector('#recallState');
          var zipInput     = form.querySelector('#recallZip');
          var countryInput = form.querySelector('#recallCountry');

          if (cityInput)    cityInput.value    = city;
          if (stateInput)   stateInput.value   = state;
          if (zipInput)     zipInput.value     = zip;
          if (countryInput) countryInput.value = country;
        });
      };

      if (window._googleMapsReadyRecall) window._recallAutoCompleteInit();
    }

    // ── UI helpers ────────────────────────────────────────────────────────

    function showSuccessMessage(form, ticketId, email, attachmentWarning) {
      var msg = document.createElement('div');
      msg.className = 'form-success recall-form__full-width';

      var mainText = document.createElement('p');
      mainText.style.margin = '0 0 4px';
      mainText.textContent = 'Your recall request has been submitted successfully! A confirmation has been sent to ' +
        email + (ticketId ? '. Reference #' + ticketId : '') + '.';
      msg.appendChild(mainText);

      if (attachmentWarning) {
        var warnText = document.createElement('p');
        warnText.style.cssText = 'margin:8px 0 0;color:#856404;background:#fff3cd;padding:8px 10px;border-radius:4px;font-size:1.3rem;';
        warnText.textContent = attachmentWarning;
        msg.appendChild(warnText);
      }

      msg.style.cssText = 'color:#155724;background:#d4edda;padding:12px;border-radius:4px;margin-bottom:20px;';
      form.parentNode.insertBefore(msg, form);
      setTimeout(function () { msg.remove(); }, 15000);
    }

    function showErrorMessage(form, message) {
      var msg = document.createElement('p');
      msg.className   = 'form-errors recall-form__full-width';
      msg.textContent = message;
      msg.style.cssText = 'color:#721c24;background:#f8d7da;padding:12px;border-radius:4px;margin-bottom:20px;';
      form.parentNode.insertBefore(msg, form);
      setTimeout(function () { msg.remove(); }, 6000);
    }

    function formatBytes(bytes) {
      if (bytes < 1024)         return bytes + ' B';
      if (bytes < 1024 * 1024)  return (bytes / 1024).toFixed(1) + ' KB';
      return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
    }
  });
})();
